import React, { useEffect, useRef, useState } from 'react';
import '../../App.css';
import '../../Home/Home.css';
import './BannerSlider.css';
import { useNavigate } from 'react-router-dom';
import { Swiper, SwiperSlide, useSwiper } from 'swiper/react';
import { Navigation, Pagination, Scrollbar, A11y, Autoplay } from 'swiper/modules';
import { setIsSelectingVehicle, setSelectedBrand, setSelectedYear, setSelectedModel, setSelectedVersion, setInternalID, setCarID } from '../../reducers/vehicle';
import { useDispatch, useSelector } from 'react-redux';
import { getFirestore, collection, query, where, getDocs } from 'firebase/firestore';
import 'swiper/css';
import 'swiper/css/bundle';
import banner01_img from '../../images/mainBG_01.webp';
import SearchIcon from "@mui/icons-material/Search";
import FilterIcon from "@mui/icons-material/FilterList";
import Logo from '../Logo';
import Button from '../Button';
import bannerVideo01 from '../../images/GoParts_24_BG_01_4mpbs.mp4';
import bannerVideo01Fallback from '../../images/banner_vid_preview_01.jpg';
import roadBg_01 from '../../images/home_road_bg_01.jpg';
import roadBg_02 from '../../images/home_road_bg_02.jpg';
import humanBg_01 from '../../images/home_humans_bg_01.jpg';
import humanBg_02 from '../../images/home_humans_bg_02.jpg';
import partsBg_01 from '../../images/home_parts_bg_01.jpg';
import magentaBg_01 from '../../images/home_magentaBg_01.jpg';
import goparts_logo_01 from '../../images/about_GoParts_bg_03.jpg';
import GenericVehicle from '../../images/0.png';
import womensHarley01 from '../../images/harley_Women_bg_01.jpg';
import womensHarley02 from '../../images/harley_Women_bg_02.jpg';
import fathersDay01 from '../../images/diadospais_banner.webp';
import fathersDay02 from '../../images/diadospais_banner_2.webp';
import acessIcon from '../../images/categories/acessorios_3_500px.webp';

import { ChevronRight, KeyboardDoubleArrowUp, Search, Edit, KeyboardArrowDown } from '@mui/icons-material';
import { AddCar } from '../../Utilities/Icons';
import { AddShoppingCart } from '@mui/icons-material';
import { CircularProgress } from '@mui/material';

import carBanner from  '../../images/car_homeBanner_01.webp';
import partsBanner from  '../../images/steps_part_01.webp';
import boxGpBanner from  '../../images/steps_GP_box_01.webp';

import GPlogoPatternBG_01 from '../../images/GoParts_Logos_Pattern_01.jpg';
import { BrandsList, BrandsListSVG, HomologBrandsSVG, BrandsListPng } from '../../Utilities/BrandsList';
import { storeInfo } from '../../Utilities/Placeholders';
import { ModelImgs } from '../../Utilities/ModelImgs';

import { getConfigData, getContentData } from '../../Whitelabel/websitesData_sd_test';
import { currentSite } from '../../App';

import harleySmallWhiteLogo from '../../images/UmuaramaMotos/harley_logo_small_white.png';
import ktmWhiteLogo from '../../images/UmuaramaMotos/ktm_logo_white.png';
import triumphWhiteLogo from '../../images/UmuaramaMotos/triumph_logo_white.png';

import harleyLogo from '../../images/brands/harley-davidson.jpg';
import ktmLogo from '../../images/brands/ktm.jpg';
import triumphLogo from '../../images/brands/triumph.jpg';

import searchCodeBg from '../../images/flag_lightGray_1920x1080.png';
import plateBg from '../../images/plateBG_25.webp';
import selectCarBg from '../../images/flag_darkGray_1920_1080.png';

function BannerSlider() {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    // Get site-specific data using the new structure
    const configData = getConfigData(currentSite);
    const contentData = getContentData(currentSite);

    const { title, content, link } = storeInfo.aboutUs;

    const [isMobile, setIsMobile] = useState(window.innerWidth <= 600);
    const [isMinDesktop, setIsMinDesktop] = useState(window.innerWidth >= 1280);
    const [isAutoplayPaused, setIsAutoplayPaused] = useState(false);
    const swiperRef = useRef(null);

    const handleResize = () => {
        setIsMobile(window.innerWidth <= 600);
        setIsMinDesktop(window.innerWidth >= 1280);
    };

    useEffect(() => {
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    // Custom autoplay pause/resume logic
    const pauseAutoplay = () => {
        if (swiperRef.current && swiperRef.current.swiper) {
            swiperRef.current.swiper.autoplay.stop();
            setIsAutoplayPaused(true);
        }
    };

    const resumeAutoplay = () => {
        if (swiperRef.current && swiperRef.current.swiper) {
            swiperRef.current.swiper.autoplay.start();
            setIsAutoplayPaused(false);
        }
    };

    // Handle input focus/blur events
    const handleInputFocus = () => {
        pauseAutoplay();
    };

    const handleInputBlur = () => {
        // Resume autoplay after a short delay to ensure user is done typing
        setTimeout(() => {
            resumeAutoplay();
        }, 1000);
    };

    const searchIcon = <svg xmlns="http://www.w3.org/2000/svg" height="48px" viewBox="0 -960 960 960" width="48px" fill="#e3e3e3"><path d="M785.23-154.08 529.15-410.15q-29.69 26.82-69.26 40.91-39.56 14.09-79.58 14.09-95.59 0-161.79-66.03-66.21-66.03-66.21-161t66.03-161.13q66.03-66.15 160.94-66.15t161.51 66.06q66.59 66.07 66.59 160.96 0 41.21-14.76 80.82-14.77 39.62-41.24 69.24l256.31 255.07-22.46 23.23ZM380.08-385.92q82.66 0 139.6-56.73t56.94-139.66q0-82.92-56.94-139.65-56.94-56.73-139.6-56.73-82.86 0-139.93 56.73-57.07 56.73-57.07 139.65 0 82.93 57.07 139.66 57.07 56.73 139.93 56.73Z"/></svg>

    const plateIcon = <svg xmlns="http://www.w3.org/2000/svg" height="48px" viewBox="0 -960 960 960" width="48px" fill="#e3e3e3"><path d="M146-212q-22.78 0-38.39-15.61Q92-243.23 92-266v-428q0-22.78 15.61-38.39T146-748h668q22.78 0 38.39 15.61T868-694v428q0 22.77-15.61 38.39Q836.78-212 814-212H146Zm0-22h668q14 0 23-9t9-23v-428q0-14-9-23t-23-9H146q-14 0-23 9t-9 23v428q0 14 9 23t23 9Zm210-74h248v-50H356v50ZM229-437h50v-50h-50v50Zm150 0h50v-50h-50v50Zm152 0h50v-50h-50v50Zm150 0h50v-50h-50v50ZM229-565h50v-50h-50v50Zm150 0h50v-50h-50v50Zm152 0h50v-50h-50v50Zm145 5h50v-50h-50v50ZM114-234v-492 492Z"/></svg>

    const selectCarIcon = <svg xmlns="http://www.w3.org/2000/svg" height="48px" viewBox="0 -960 960 960" width="48px" fill="#e3e3e3"><path d="M568.38-120q-18.8 0-36.17-7.23-17.36-7.23-31.06-20.92L330.31-318.46l19.84-20.85q8.39-8.38 19.49-10.46 11.1-2.08 22.98 1.39L480-328.46v-295.39q0-6.57 4.38-10.98 4.39-4.4 11.12-4.4 6.73 0 11 4.4 4.27 4.41 4.27 10.98v336.16l-140.69-35.77 152.54 153.84q9.3 9.54 20.88 14.2 11.58 4.65 24.88 4.65h148.54q43.39 0 74-30.62 30.62-30.63 30.62-73.99v-131.54q0-6.58 4.38-10.98 4.39-4.41 11.12-4.41 6.73 0 11 4.41 4.27 4.4 4.27 10.98v131.54q0 56.84-39.27 96.11Q773.77-120 716.92-120H568.38Zm25.54-261.54v-160.77q0-6.84 4.39-11.11 4.38-4.27 11.11-4.27 6.73 0 11 4.4 4.27 4.41 4.27 10.98v160.77h-30.77Zm113.7 0v-100.77q0-6.57 4.38-10.98 4.38-4.4 11.12-4.4 6.73 0 11 4.4 4.26 4.41 4.26 10.98v100.77h-30.76Zm9.3 230.77h-194.3H716.92ZM175.38-240q-23.05 0-39.22-16.16Q120-272.33 120-295.38v-449.24q0-23.05 16.16-39.22Q152.33-800 175.38-800h569.24q23.05 0 39.22 16.16Q800-767.67 800-744.62v146.93h-30.77v-146.93q0-9.23-7.69-16.92-7.69-7.69-16.92-7.69H175.38q-9.23 0-16.92 7.69-7.69 7.69-7.69 16.92v449.24q0 9.23 7.69 16.92 7.69 7.69 16.92 7.69h86.08L292-240H175.38Z"/></svg>

    const handleAboutUsClick = () => {
        window.open(`${link}`, '_blank');
    }

    const { selectedBrand, isSelectingVehicle, selectedYear, selectedModel, selectedVersion, modelSeries } = useSelector(state => state.vehicle);

    const modelSeriesImg = (modelId) => {
        return ModelImgs[modelId] || GenericVehicle;
    };

    const openVehicleSelect = () => {
        //console.log('version: ', selectedVersion);
        if (configData.brands.length === 1 && !selectedVersion) {
            vehicleSelectWithBrand(configData.brands[0]);
        } else {
            if (selectedVersion) {
                if (configData.defaultStore === 'NissulYamaha' || configData.defaultStore === 'BelcarYamaha') {
                    navigate('/produtos/Peças');
                } else {
                    navigate('/categorias');
                }
            } else {
                dispatch(setIsSelectingVehicle(!isSelectingVehicle));
            }
        }
    };

    const progressCircle = useRef(null);
    const progressContent = useRef(null);
    const onAutoplayTimeLeft = (s, time, progress) => {
      progressCircle.current.style.setProperty('--progress', 1 - progress);
      progressContent.current.textContent = `${Math.ceil(time / 1000)}s`;
    };

    const vehicleSelectWithBrand = (brand) => {
        dispatch(setSelectedVersion(''));
        dispatch(setSelectedModel(''));
        dispatch(setSelectedYear(''));
        dispatch(setSelectedBrand(brand));
        dispatch(setIsSelectingVehicle(true));
    }

    const openVehicleSelectOnly = () => {
        dispatch(setIsSelectingVehicle(true));
    }

    // License plate handling functions
    const [licensePlate, setLicensePlate] = useState('');
    const [loadingPlate, setLoadingPlate] = useState(false);

    // Part code handling functions
    const [partCode, setPartCode] = useState('');

    const formatLicensePlate = (input) => {
        // Remove all non-alphanumeric characters
        const cleaned = input.replace(/[^A-Za-z0-9]/g, '');
        
        // Format as ABC-1234 or ABC1D23 (Mercosul format)
        if (cleaned.length <= 3) {
            return cleaned.toUpperCase();
        } else if (cleaned.length <= 7) {
            return cleaned.toUpperCase();
        } else {
            return cleaned.substring(0, 7).toUpperCase();
        }
    };

    const validateLicensePlate = (input) => {
        // Brazilian license plate validation (old format: ABC-1234, new format: ABC1D23)
        const oldFormat = /^[A-Z]{3}-?[0-9]{4}$/;
        const newFormat = /^[A-Z]{3}[0-9][A-Z][0-9]{2}$/;
        
        return oldFormat.test(input) || newFormat.test(input);
    };

    async function loadCarbyCode(year, brand, modelo, cilindrada, modeloIPVA, modeloIPVAAux, fuel) {
        const allCars = [];
        let allCarsnoFilter = [];
      
        try {
          // First check for internet connection if running in a non-web environment
          if (typeof window === 'undefined') { // This is equivalent to !kIsWeb in Dart
            const result = await fetch('https://www.google.com');
            if (!result.ok) {
              throw new Error('Not connected to the internet');
            }
          }

        let dealersQuery = query(
            collection(getFirestore(), 'cars'),
            where('ipvaNames', 'array-contains', modeloIPVA.toLowerCase()),
            where('yearStart', '<=', year),
            where('yearEnd', '>=', year)
        );
        
        let snapProducts = await getDocs(dealersQuery);
        
        // Debugging output
        // console.log("Modelo IPVA:", modeloIPVA);
        // console.log("Year:", year);
        // console.log("Snap Products:", snapProducts);

          // If no results found for modeloIPVA, try modeloIPVAAux
          if (snapProducts.empty) {
            dealersQuery = query(
                collection(getFirestore(), 'cars'),
                where('ipvaNames', 'array-contains', modeloIPVAAux.toLowerCase())
              );
            snapProducts = await getDocs(dealersQuery);
          }
      
          // Convert Firestore documents to GPCar instances
          allCarsnoFilter = snapProducts.docs.map(doc => doc.data()); // Here we extract plain objects
      
        } catch (error) {
          console.error('Error fetching cars:', error);
          return new GPCar(); // Return an empty GPCar in case of error
        }
      
        // Filter based on cilindrada and fuel if more than 1 car is found
        if (allCarsnoFilter.length > 1) {
          if (cilindrada !== 0 && fuel.length > 0) {
            const mycar = getClosestValueInArray(allCarsnoFilter, cilindrada, fuel);
            if (mycar.brandID !== 0 && configData.brands.includes(mycar.brand.toLowerCase())) {
              allCars.push(mycar);
              return mycar;
            } else {
              return new GPCar(); // Return an empty GPCar if no match
            }
          }
        } else if (allCarsnoFilter.length === 1) {
          // Return the single car if it's found and is from a valid brand
          if (configData.brands.includes(allCarsnoFilter[0].brand.toLowerCase())) {
            allCars.push(allCarsnoFilter[0]);
            return allCarsnoFilter[0];
          }
        }
      
        // Return GPCar with -1 brandID if no car matches the store brands
        if (allCarsnoFilter.length > 0 && !configData.brands.includes(allCarsnoFilter[0].brand.toLowerCase())) {
          return new GPCar(-1);
        }
      
        // If nothing is found, return an empty GPCar
        return new GPCar();
      }
      
      // Helper functions (these will be part of your system)
      
      // GPCar model - Define according to your system
      class GPCar {
        constructor(brandID = 0) {
          this.brandID = brandID;
          this.brand = "";
          this.name = "";
          this.version = "";
          this.modelSeries = "";
          this.InternalID = "";
          this.carId = "";
          this.engine = "";
        }
      
        static fromDocument(doc) {
          const data = doc.data();
          const car = new GPCar();
          car.brandID = data.brandID || 0;
          car.brand = data.brand || "";
          car.name = data.name || "";
          car.version = data.version || "";
          car.modelSeries = data.modelSeries || "";
          car.InternalID = data.InternalID || "";
          car.carId = data.carId || "";
          car.engine = data.engine || "";
          return car;
        }
      }
      
      // Example: getClosestValueInArray (adjust based on actual logic)
      function getClosestValueInArray(cars, cilindrada, fuel) {
        // Calculate the allowed variance (5%)
        const minCilindrada = cilindrada * 0.95;
        const maxCilindrada = cilindrada * 1.05;

        // Filter cars that have a cilindrada within the 5% range and match the fuel
        const filteredCars = cars.filter(car => {
            return (
            car.displacement >= minCilindrada &&
            car.displacement <= maxCilindrada &&
            car.fuel.toLowerCase() === fuel.toLowerCase()
            );
        });

        // If no cars meet the criteria, return null
        if (filteredCars.length === 0) {
            return null;
        }

        // Find the car with the closest cilindrada
        let closestCar = filteredCars[0];
        let smallestDifference = Math.abs(filteredCars[0].displacement - cilindrada);

        for (const car of filteredCars) {
            const difference = Math.abs(car.displacement - cilindrada);
            if (difference < smallestDifference) {
            smallestDifference = difference;
            closestCar = car;
            }
        }

        return closestCar;
    }

    const handleLicensePlateChange = (event) => {
        const input = event.target.value;
        const formatted = formatLicensePlate(input);
        setLicensePlate(formatted);
        
        // Auto-submit when length reaches 7 characters
        if (formatted.length === 7) {
            handleLicensePlateSubmit(formatted);
        }
    };

    const handleLicensePlateSubmit = async (plateValue = licensePlate) => {
        setLoadingPlate(true);
        if (validateLicensePlate(plateValue)) {
            const cleanPlate = plateValue.replace('-', '');
            const url = `https://wdapi.com.br/placas/${cleanPlate}/17c5532261f53e63c29fefcef12d6ff3`;

            try {
                const response = await fetch(url);
                
                if (response.ok) {
                    const responseBody = await response.json();
                    
                    const brand = responseBody["MARCA"];
                    const year = parseInt(responseBody["anoModelo"]);
                    const model = responseBody["SUBMODELO"];
                    
                    let modeloIPVA = "";
                    let modeloIPVAAux = "";
                    let cilindrada = 0;
                    let fuel = "";
                    
                    try {
                        modeloIPVA = responseBody["extra"]["modelo"] || "";
                    } catch (e) {
                        modeloIPVA = "";
                    }
                    
                    try {
                        modeloIPVAAux = responseBody["marcaModelo"] || "";
                    } catch (e) {
                        modeloIPVAAux = "";
                    }
                    
                    try {
                        cilindrada = parseInt(responseBody["extra"]["cilindradas"]) || 0;
                    } catch (e) {
                        cilindrada = 0;
                    }
                    
                    try {
                        fuel = responseBody["extra"]["combustivel"] || "";
                    } catch (e) {
                        fuel = "";
                    }
                    
                    let currentcar = await loadCarbyCode(year, brand, model, cilindrada, modeloIPVA, modeloIPVAAux, fuel);
                    
                    if (currentcar && currentcar.brandID !== 0) {
                        // Set all the vehicle data exactly like VehicleSelect does
                        dispatch(setInternalID(currentcar.InternalID));
                        dispatch(setSelectedBrand(currentcar.brand.toLowerCase()));
                        dispatch(setSelectedYear(year));
                        dispatch(setSelectedModel(model));
                        dispatch(setSelectedVersion(currentcar.engine));
                        dispatch(setCarID(currentcar.carId));
                        dispatch(setIsSelectingVehicle(false));
                        
                        setLoadingPlate(false);
                        navigate(`categorias/`);
                        return;
                    } else {
                        console.error('No matching car found for the license plate');
                    }
                } else {
                    console.error(`Request failed with status: ${response.status}.`);
                }
            } catch (error) {
                console.error('An error occurred while fetching car details:', error);
            }
        }
        setLoadingPlate(false);
    };

    const handlePartCodeChange = (event) => {
        setPartCode(event.target.value);
    };

    const handlePartCodeSearch = () => {
        if (partCode.trim()) {
            navigate(`/busca/${partCode.trim()}`);
        }
    };

    return (
        <div>
            <Swiper
                ref={swiperRef}
                modules={[Navigation, Pagination, Scrollbar, Autoplay ]}
                loop={true}
                spaceBetween={0}
                slidesPerView={1}
                navigation={true}
                pagination={{ clickable: true }}
                scrollbar={{ draggable: true }}
                autoplay={{
                    delay: 15000,
                    disableOnInteraction: true,
                }}
                onAutoplayTimeLeft={onAutoplayTimeLeft}
            >

                <div className="autoplay-progress" slot="container-end">
                    <svg viewBox="0 0 48 48" ref={progressCircle}>
                        <circle cx="24" cy="24" r="20"></circle>
                    </svg>
                    <span ref={progressContent}></span>
                </div>

                {configData.defaultStore === 'GoParts' 
                    ?
                        <>

                            {/* <SwiperSlide>
                                <div className='defaultBannerBG' style={{backgroundImage: `url(${isMobile ? womensHarley01 : womensHarley02})`}}>

                                    <div className='titleContainer'>
                                        <h2 style={{fontSize: '30px'}}>Para as Mães que Aceleram Corações</h2>
                                        <span style={{color: 'white', fontSize: '18px'}}>Neste dia das mães, presenteie sua mãe aventureira</span>
                                    </div>
                                    <Button
                                        className='giantButton'
                                        label='Ver produtos'
                                        onClick={() => navigate('/produtos/dia-das-maes')}
                                    />
                                </div>
                            </SwiperSlide> */}

                            <SwiperSlide>
                                <div className='defaultBannerBG' style={{backgroundImage: `url(${isMobile ? fathersDay01 : fathersDay02})`}}>

                                    <div className='titleContainer'>
                                        <h2 style={{fontSize: '24px', fontWeight: 'bold'}}>PARA PAIS APAIXONADOS POR CARROS</h2>
                                        <span style={{color: 'white', fontSize: '18px'}}>Neste dia dos pais, presenteie seu pai <mark>gearhead</mark>!</span>
                                    </div>
                                    <Button
                                        className='giantButton'
                                        label='Ver produtos'
                                        onClick={() => navigate('/produtos/dia-dos-pais')}
                                    />
                                </div>
                            </SwiperSlide>

                            <SwiperSlide>
                                <div className='rowToColumn800 dynamicBannerContainer'>

                                    <div className='dynamicBannerChild' style={{backgroundImage: `url(${searchCodeBg})`, backgroundSize: 'cover', backgroundPosition: 'center'}}>
                                       <h2>Procure pelo código da peça,</h2>
                                       <div className='row' style={{gap: '10px'}}>
                                        <input 
                                            type="text" 
                                            placeholder='digite o código' 
                                            value={partCode}
                                            onChange={handlePartCodeChange}
                                            onFocus={handleInputFocus}
                                            onBlur={handleInputBlur}
                                            onKeyPress={(e) => {
                                                if (e.key === 'Enter') {
                                                    handlePartCodeSearch();
                                                }
                                            }}
                                        />
                                        <Button
                                            className='buttonColorThird smallButton'
                                            label='Buscar'
                                            onClick={handlePartCodeSearch}
                                        />
                                       </div>
                                    </div>

                                    <div className='dynamicBannerChild' style={{backgroundImage: `url(${plateBg})`, backgroundSize: 'cover', backgroundPosition: 'center'}}>
                                        <h2>pela placa do veículo</h2>
                                        <div className='row' style={{gap: '10px'}}>
                                            <div className='plateContainer'>
                                                <input 
                                                    type="text" 
                                                    placeholder='digite a placa' 
                                                    className='plateInput'
                                                    value={licensePlate}
                                                    onChange={handleLicensePlateChange}
                                                    onFocus={handleInputFocus}
                                                    onBlur={handleInputBlur}
                                                    disabled={loadingPlate}
                                                />
                                                {loadingPlate && (
                                                    <div style={{marginLeft: '10px'}}>
                                                        <CircularProgress size={20} sx={{ color: 'white' }} />
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                    <div className='dynamicBannerChild' style={{backgroundImage: `url(${selectCarBg})`, backgroundSize: 'cover', backgroundPosition: 'center'}}>
                                        {!selectedVersion 
                                        ?
                                            <h2>ou selecione o modelo do seu veículo</h2>
                                        :
                                            <div className='column center'>
                                                <h2>ou veja peças compatíveis</h2>
                                                <div className='row selectedVehicleHomeBanner' style={{fontSize: '14px', fontWeight: '300'}} onClick={openVehicleSelectOnly}>
                                                    <span style={{alignItems: 'center', whiteSpace: 'wrap'}} >{selectedModel} {selectedYear} {selectedVersion}</span>
                                                    <a style={{whiteSpace: 'nowrap'}}><Edit style={{fontSize: '16px', marginLeft: '6px'}}/> alterar</a>
                                                </div>
                                            </div>
                                        }
                                        <div className='row' style={{gap: '10px'}}>
                                            <Button
                                                className='giantButton'
                                                iconStart={<span><AddCar style={{color: 'var(--giantButtonGradientContent)', position: 'relative', zIndex: 1}}/></span>}
                                                label={!selectedVersion ? 'Selecionar veículo' : 'Peças compatíveis'}
                                                onClick={openVehicleSelect}
                                            />
                                        </div>
                                    </div>

                                </div>
                            </SwiperSlide>

                            <SwiperSlide>
                                <div className='defaultBannerBG' style={{gap: '6px', backgroundImage: `url(${bannerVideo01Fallback})`}}>
                                {/* <div className='bannerContainer'>
                                    <video autoPlay muted loop className='bannerVideo' poster={bannerVideo01Fallback}>
                                        <source src={bannerVideo01} type="video/mp4" />
                                    </video> */}

                                    {/* {!selectedVersion &&
                                        <div className='titleContainer not500' style={{flexDirection: 'column'}}>
                                            <h1><mark>1.</mark> Selecione seu veículo</h1>
                                            <h1><mark>2.</mark> Encontre a peça desejada</h1>
                                            <h1><mark>3.</mark> Compre e receba</h1>
                                        </div>
                                    } */}

                                    {!selectedVersion &&
                                        <h2>Selecione seu veículo:</h2>
                                    }

                                    {!selectedVersion &&
                                        <div className='only500'>
                                            <h1>Selecione seu veículo:</h1>
                                        </div>
                                    }
                                    
                                    {selectedVersion &&
                                        <h2>Veículo selecionado:</h2>
                                    }
                                    
                                    {!selectedVersion
                                        ?
                                            <div className='column center' style={{gap: '4px'}}>
                                                <div className='bannerRowBrands'>
                                                    {configData.brands.map((item) => {
                                                        const brandName = item.charAt(0).toUpperCase() + item.slice(1);
                                                        const imageSrc = BrandsList[brandName];
                                                        return imageSrc ? (
                                                        <div
                                                            className='headerFilterOption'
                                                            key={item}
                                                            onClick={() => vehicleSelectWithBrand(item)}
                                                        >
                                                            <img className='headerFilterBrandLogo' src={imageSrc} alt={item} />
                                                        </div>
                                                        ) : (
                                                        <div className='headerFilterOption' style={{ color: 'white' }} key={item}>
                                                            {item}
                                                        </div>
                                                        );
                                                    })}
                                                </div>
                                                <div className='column center' style={{gap: '6px'}}>
                                                    <span>ou</span>
                                                    <Button
                                                        onClick={openVehicleSelectOnly}
                                                        className="buttonColorThird smallButton"
                                                        label="Encontre pela placa"
                                                        iconStart={<Search/>}
                                                    />
                                                </div>
                                            </div>
                                        :
                                            <div className='column center' style={{gap: '20px'}}>
                                                <div className='row selectedVehicleHomeBanner' onClick={openVehicleSelectOnly}>
                                                    <img className='catVehicleImg' src={modelSeriesImg(modelSeries)}/>
                                                    <span style={{alignItems: 'center', whiteSpace: 'wrap'}} >{selectedModel} {selectedYear} {selectedVersion}</span>
                                                    <a style={{whiteSpace: 'nowrap'}}><Edit style={{fontSize: '16px', marginLeft: '6px'}}/> alterar</a>
                                                </div>
                                                <Button
                                                    className='giantButton'
                                                    iconStart={<span><AddShoppingCart style={{color: 'var(--giantButtonGradientContent)', position: 'relative', zIndex: 1}}/></span>}
                                                    label='Peças compatíveis'
                                                    onClick={openVehicleSelect}
                                                />
                                            </div>
                                    }
                                </div>
                            </SwiperSlide>

                            <SwiperSlide>
                                {/* <div className='defaultBannerBG' style={{backgroundColor: 'var(--secondColor)'}}> */}
                                <div className='defaultBannerBG' style={{backgroundImage: `url(${humanBg_02})`}}>

                                    {/* <img src={Logo} className='BannerLogo'/> */}

                                    <div className='stepsBannerRow'>
                                        <img src={carBanner} className='bannerStepsImg'/>
                                        <ChevronRight/>
                                        <img src={partsBanner} className='bannerStepsImg'/>
                                        <ChevronRight/>
                                        <img src={boxGpBanner} className='bannerStepsImg'/>
                                    </div>

                                    <div className='titleContainer'>
                                        <h1><mark>1.</mark> Selecione seu veículo</h1>
                                        <h1><mark>2.</mark> Encontre a peça desejada</h1>
                                        <h1><mark>3.</mark> Compre e receba</h1>
                                    </div>

                                    {/* <h1>Autopeças <mark>novas e origniais</mark> compatíveis com <mark>seu veículo</mark> e enviadas diretamente pelas <mark>concessionárias</mark>.</h1> */}
                                    
                                    {/* {!selectedVersion &&
                                        <div className='startHereContainer'>
                                            <div className='startHere' onClick={openVehicleSelect}>
                                                <KeyboardDoubleArrowUp style={{color: 'var(--secondColor)'}}/>
                                                <span>Comece aqui</span>
                                            </div>
                                        </div>
                                    } */}

                                    <div className='row center'style={{gap: '10px', marginBottom: '20px'}}>
                                        <Button
                                            className='giantButton'
                                            iconStart={<span><AddCar style={{color: 'var(--giantButtonGradientContent)', position: 'relative', zIndex: 1}}/></span>}
                                            label={!selectedVersion ? 'Selecionar veículo' : 'Peças compatíveis'}
                                            onClick={openVehicleSelect}
                                        />

                                        {/* <Button
                                            className='buttonStyle colorButtonMain largeButton'
                                            label='Encontrar peças'
                                        /> */}
                                    </div>


                                    {/* <div className='stepsBannerRow'>
                                        <img src={carBanner} className='bannerStepsImg'/>
                                        <ChevronRight/>
                                        <img src={partsBanner} className='bannerStepsImg'/>
                                        <ChevronRight/>
                                        <img src={boxGpBanner} className='bannerStepsImg'/>
                                    </div> */}

                                </div>
                            </SwiperSlide>
                            
                            <SwiperSlide>
                                <div className='defaultBannerBG' style={{backgroundImage: `url(${partsBg_01})`}}>

                                    <div className='titleContainer'>
                                        <h2>Autopeças <mark>novas e genuínas</mark> de concessionárias de todo o Brasil:</h2>
                                    </div>

                                    <div className='column center' style={{width: '100%'}}>
                                        {/* <h1 style={{padding: '20px'}}>Autopeças novas e genuínas das maiores montadoras e fabricantes homologados:</h1> */}
                                        <div className='row' style={{gap: '6px', flexWrap: 'wrap', justifyContent: 'center', paddingInline: '5px'}}>
                                            {Object.entries(BrandsListSVG).map(([brandName, brandLogo]) => (
                                                <img className='brandLogosBanner' key={brandName} src={brandLogo} alt={brandName} />
                                            ))}
                                        </div>
                                        <div className='row' style={{columnGap: '20px', flexWrap: 'wrap', justifyContent: 'center', borderTop: '1px solid rgba(255, 255, 255, 0.3)', padding: '20px 0', marginTop: '20px'}}>
                                            {Object.entries(HomologBrandsSVG).map(([brandName, brandLogo]) => (
                                                <img className='brandLogosBannerWide' key={brandName} src={brandLogo} alt={brandName} />
                                            ))}
                                        </div>
                                        <Button
                                            className='buttonColorSecond smallButton'
                                            label={storeInfo.aboutUs.linkCta}
                                            onClick={handleAboutUsClick}
                                        />
                                    </div>

                                    {/* {!selectedVersion &&
                                        <div className='startHereContainer'>
                                            <div className='startHere' onClick={openVehicleSelect}>
                                                <KeyboardDoubleArrowUp style={{color: 'var(--secondColor)'}}/>
                                                <span>Comece aqui</span>
                                            </div>
                                        </div>
                                    } */}

                                </div>
                            </SwiperSlide>
                            
                            {/* <SwiperSlide>
                                <div className='defaultBannerBG' style={{backgroundImage: `url(${goparts_logo_01})`}}>

                                    <div className='column center' style={{width: '100%', maxWidth: '800px', gap: '20px'}}>
                                        <div className='titleContainer'>
                                            <h1>{content[0]}</h1>
                                        </div>
                                        <span className='aboutUsBannerSpan'>{content[1]}</span>
                                        <div className='row center' style={{gap: '10px'}}>
                                            <Button
                                                className='buttonColorSecond smallButton'
                                                label={storeInfo.aboutUs.linkCta}
                                                onClick={handleAboutUsClick}
                                            />
                                            <Button
                                                className='buttonColorThird smallButton'
                                                label='Comprar peças'
                                                onClick={openVehicleSelect}
                                            />
                                        </div>
                                    </div>

                                    {!selectedVersion &&
                                        <div className='startHereContainer'>
                                            <div className='startHere' onClick={openVehicleSelect}>
                                                <KeyboardDoubleArrowUp style={{color: 'var(--secondColor)'}}/>
                                                <span>Comece aqui</span>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </SwiperSlide> */}
                        </>
                    :
                        <>
                            {configData.defaultStore === 'UmuaramaMotos'
                                ?
                                <>
                                    <SwiperSlide>
                                        <div className='defaultBannerBG' style={{backgroundImage: `url(${contentData.banner01})`}}>
                                            <div className='column center' style={{justifyContent: 'center', alignItems: 'center', gap: '20px', textAlign: 'center', paddingInline: '20px', marginTop: '40px'}}>
                                                {/* <img className='BannerLogo' src={contentData.bannerLogoWhite} alt={`${configData.defaultStore} logo`} loading='lazy'/>  */}
                                                <div className='row center' style={{gap: '20px', justifyContent: 'center', alignItems: 'center'}}>
                                                    <img className='harleyBLogo' src={harleySmallWhiteLogo} alt='Harley-Davidson logo'/>
                                                    <img className='ktmBLogo' src={ktmWhiteLogo} alt='KTM logo'/>
                                                    <img className='triumphBLogo' src={triumphWhiteLogo} alt='Triumph logo'/>
                                                </div>
                                                <h2 className='bannerHighlightText' dangerouslySetInnerHTML={{ __html: contentData.bannerHighlight }} />

                                                <div className='bannerRowBrands'>
                                                    <div className='headerFilterOption' onClick={() => navigate('/categorias/harley-davidson')}>
                                                        <img className='headerFilterBrandLogo' src={harleyLogo} alt='harley-davidson-logo'/>
                                                    </div>
                                                    <div className='headerFilterOption' onClick={() => navigate('/categorias/ktm')}>
                                                        <img className='headerFilterBrandLogo' src={ktmLogo} alt='ktm-logo'/>
                                                    </div>
                                                    <div className='headerFilterOption' onClick={() => navigate('/categorias/triumph')}>
                                                        <img className='headerFilterBrandLogo' src={triumphLogo} alt='triumph-logo'/>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </SwiperSlide>

                                    {/* <SwiperSlide>
                                        <div className='defaultBannerBG' style={{backgroundImage: `url(${contentData.banner01})`}}>
                                            <div className='column center' style={{justifyContent: 'center', alignItems: 'center', gap: '20px', textAlign: 'center', paddingInline: '20px', marginTop: '40px'}}>
                                                <div className='row center' style={{gap: '20px', justifyContent: 'center', alignItems: 'center'}}>
                                                    <img className='harleyBLogo' src={harleySmallWhiteLogo} alt='Harley-Davidson logo'/>
                                                    <img className='ktmBLogo' src={ktmWhiteLogo} alt='KTM logo'/>
                                                    <img className='triumphBLogo' src={triumphWhiteLogo} alt='Triumph logo'/>
                                                </div>
                                                <h2 className='bannerHighlightText' dangerouslySetInnerHTML={{ __html: contentData.bannerHighlight }} />
                                                <Button
                                                    className='giantButton'
                                                    label='Comprar peças'
                                                    onClick={() => navigate('/categorias')}
                                                />
                                            </div>
                                        </div>
                                    </SwiperSlide> */}

                                    <SwiperSlide>
                                        <div className='defaultBannerBG' style={{backgroundImage: `url(${contentData.banner04})`}}>
                                            <div className='column center' style={{justifyContent: 'center', alignItems: 'center', gap: '20px', textAlign: 'center', paddingInline: '20px', marginTop: '40px'}}>
                                                <h2 className='bannerHighlightText' style={{fontWeight: 'bold', fontSize: '36px'}}>Pilote com Estilo</h2>
                                                <h2 className='bannerHighlightText'>Confira tudo em vestuário das melhores marcas dos motociclistas.</h2>
                                                <Button
                                                    className='giantButton'
                                                    label='Tudo em Vestuário'
                                                    onClick={() => navigate('/produtos/vestuario')}
                                                />
                                            </div>
                                        </div>
                                    </SwiperSlide>

                                    <SwiperSlide>
                                        <div className='defaultBannerBG' style={{backgroundImage: `url(${contentData.banner05})`}}>
                                            <div className='column center' style={{justifyContent: 'center', alignItems: 'center', gap: '20px', textAlign: 'center', paddingInline: '20px', marginTop: '40px'}}>
                                                <img className='BannerLogo' src={harleySmallWhiteLogo} alt='Harley-Davidson logo' loading='lazy'/> 
                                                <h2 className='bannerHighlightText'>Peças originais Harley-Davidson</h2>
                                                <Button
                                                    className='giantButton'
                                                    label='Comprar em Harley-Davidson'
                                                    onClick={() => navigate('/categorias/harley-davidson')}
                                                />
                                            </div>
                                        </div>
                                    </SwiperSlide>

                                    <SwiperSlide>
                                        <div className='defaultBannerBG' style={{backgroundImage: `url(${contentData.banner02})`}}>
                                            <div className='column center' style={{justifyContent: 'center', alignItems: 'center', gap: '20px', textAlign: 'center', paddingInline: '20px', marginTop: '40px'}}>
                                                <img className='BannerLogo' src={ktmWhiteLogo} alt='KTM logo' loading='lazy'/> 
                                                <h2 className='bannerHighlightText'>Peças originais KTM</h2>
                                                <Button
                                                    className='giantButton'
                                                    label='Comprar em KTM'
                                                    onClick={() => navigate('/categorias/ktm')}
                                                />
                                            </div>
                                        </div>
                                    </SwiperSlide>

                                    <SwiperSlide>
                                        <div className='defaultBannerBG' style={{backgroundImage: `url(${contentData.banner03})`}}>
                                            <div className='column center' style={{justifyContent: 'center', alignItems: 'center', gap: '20px', textAlign: 'center', paddingInline: '20px', marginTop: '40px'}}>
                                                <img className='BannerLogo' src={triumphWhiteLogo} alt='Triumph logo' loading='lazy'/> 
                                                <h2 className='bannerHighlightText'>Peças originais Triumph</h2>
                                                <Button
                                                    className='giantButton'
                                                    // className='giantButton disabledButton'
                                                    // label='Em breve'
                                                    label='Comprar em Triumph'
                                                    onClick={() => navigate('/categorias/triumph')}
                                                />
                                            </div>
                                        </div>
                                    </SwiperSlide>
                                </>
                                :
                                <>
                                {configData.brands.length === 1
                                    ?
                                        <>
                                            {configData.defaultStore !== 'Peças Kia'
                                                ?
                                                    <SwiperSlide>
                                                        <div className='defaultBannerBG' style={{backgroundImage: `url(${contentData.banner01})`}}>
            
                                                            <div className='column center' style={{justifyContent: 'center', alignItems: 'center', gap: '20px', textAlign: 'center', paddingInline: '20px'}}>
                                                                {(!selectedVersion || configData.noVehicle) &&
                                                                    <img className='BannerLogo' src={contentData.bannerLogoWhite} alt={`${configData.defaultStore} logo`} loading='lazy'/> 
                                                                }
                                                                <h2 className='bannerHighlightText' dangerouslySetInnerHTML={{ __html: contentData.bannerHighlight }} />
                                                            </div>
            
                                                            {/* {!selectedVersion &&
                                                                <div className='titleContainer' style={{flexDirection: 'column'}}>
                                                                    <h1><mark>1.</mark> Selecione seu veículo</h1>
                                                                    <h1><mark>2.</mark> Encontre a peça desejada</h1>
                                                                    <h1><mark>3.</mark> Compre e receba</h1>
                                                                </div>
                                                            } */}
                                                            
                                                            {!selectedVersion
                                                            ?
                                                                <div className='column center' style={{gap: '10px'}}>
                                                                    <Button
                                                                        className='giantButton'
                                                                        iconStart={<span><AddCar style={{position: 'relative', zIndex: 1}}/></span>}
                                                                        label='Selecionar veículo'
                                                                        onClick={openVehicleSelect}
                                                                    />
                                                                </div>
                                                            :
                                                                <div className='column center' style={{gap: '20px'}}>
                                                                    {!configData.noVehicle &&
                                                                        <div className='row selectedVehicleHomeBanner' onClick={openVehicleSelectOnly}>
                                                                            <img className='catVehicleImg' src={modelSeriesImg(modelSeries)}/>
                                                                            <span style={{alignItems: 'center', whiteSpace: 'wrap'}} >{selectedModel} {selectedYear} {selectedVersion}</span>
                                                                            <a style={{whiteSpace: 'nowrap'}}><Edit style={{fontSize: '16px', marginLeft: '6px'}}/> alterar</a>
                                                                        </div>
                                                                    }
                                                                    <Button
                                                                        className='giantButton'
                                                                        iconStart={<span><AddShoppingCart style={{color: 'var(--giantButtonGradientContent)', position: 'relative', zIndex: 1}}/></span>}
                                                                        label={configData.noVehicle ? 'Comprar peças' : 'Peças compatíveis'}
                                                                        onClick={openVehicleSelect}
                                                                    />
                                                                </div>
                                                            }
                                                        </div>
                                                    </SwiperSlide>
                                                :
                                                    <SwiperSlide>
                                                        <div className='defaultBannerBG' style={{backgroundImage: `url(${ !isMobile ? contentData.banner01 : contentData.banner06})`}}>
                                                            <div className='rowToColumn' style={{gap: '40px'}}>
                                                                <img className='BannerLogoLarge' src={contentData.bannerLogoWhite} alt={`${configData.defaultStore} logo`} loading='lazy'/> 
                                                                
                                                                {!selectedVersion
                                                                    ?
                                                                        <div className='column center' style={{gap: '20px'}}>
                                                                            <div className='titleContainer' style={{display: 'flex', flexDirection: 'column', gap: '10px'}}>
                                                                                <h1><mark>1.</mark> Selecione seu veículo</h1>
                                                                                <h1><mark>2.</mark> Encontre a peça desejada</h1>
                                                                                <h1><mark>3.</mark> Compre e receba</h1>
                                                                            </div>
                                                                            <Button
                                                                                className='giantButton'
                                                                                iconStart={<span><AddCar style={{position: 'relative', zIndex: 1}}/></span>}
                                                                                label='Selecionar veículo'
                                                                                onClick={openVehicleSelect}
                                                                            />
                                                                        </div>
                                                                    :
                                                                        <div className='column center' style={{gap: '20px'}}>
                                                                            <div className='row selectedVehicleHomeBanner' onClick={openVehicleSelectOnly}>
                                                                                <img className='catVehicleImg' src={modelSeriesImg(modelSeries)}/>
                                                                                <span style={{alignItems: 'center', whiteSpace: 'wrap'}} >{selectedModel} {selectedYear} {selectedVersion}</span>
                                                                                <a style={{whiteSpace: 'nowrap'}}><Edit style={{fontSize: '16px', marginLeft: '6px'}}/> alterar</a>
                                                                            </div>
                                                                            <Button
                                                                                className='giantButton'
                                                                                iconStart={<span><AddShoppingCart style={{color: 'var(--giantButtonGradientContent)', position: 'relative', zIndex: 1}}/></span>}
                                                                                label= 'Peças compatíveis'
                                                                                onClick={openVehicleSelect}
                                                                            />
                                                                        </div>
                                                                }
                                                            </div>
                                                        </div>
                                                    </SwiperSlide>
                                            }

                                            {configData.defaultStore !== 'NissulYamaha' && configData.defaultStore !== 'BelcarYamaha'
                                            ?
                                                <SwiperSlide>
                                                    <div className='defaultBannerBG' style={{backgroundImage: `url(${contentData.banner02})`}}>
    
                                                        <div className='stepsBannerRow'>
                                                            <img src={contentData.car123 === '' ? carBanner : contentData.car123} className='bannerStepsImg'/>
                                                            <ChevronRight/>
                                                            <img src={partsBanner} className='bannerStepsImg'/>
                                                            <ChevronRight/>
                                                            <img src={contentData.box123 === '' ? boxGpBanner : contentData.box123} className='bannerStepsImg'/>
                                                        </div>
        
                                                        <div className='titleContainer' style={{display: 'flex', flexDirection: 'column', gap: configData.defaultStore === 'Peças Kia' ? '10px' : '0'}}>
                                                            <h1><mark>1.</mark> Selecione seu veículo</h1>
                                                            <h1><mark>2.</mark> Encontre a peça desejada</h1>
                                                            <h1><mark>3.</mark> Compre e receba</h1>
                                                        </div>
                                                        
                                                        {!selectedVersion &&
                                                            <div className='column center' style={{gap: '10px'}}>
                                                                <Button
                                                                    className='giantButton'
                                                                    iconStart={<span><AddCar style={{position: 'relative', zIndex: 1}}/></span>}
                                                                    label='Selecionar veículo'
                                                                    onClick={openVehicleSelect}
                                                                />
                                                            </div>
                                                        }
                                                    </div>
                                                </SwiperSlide>
                                            :
                                                <SwiperSlide>
                                                    <div className='defaultBannerBG' style={{backgroundImage: `url(${contentData.banner02})`}}>
                                                        <div className='column center' style={{gap: '10px'}}>
                                                            <h1 style={{fontSize: '36px'}}>Tudo em Yamaha</h1>
                                                            <h2 className='bannerHighlightText'>Confira nossa linha completa de peças <mark>genuínas Yamaha</mark></h2>
                                                            <Button
                                                                className='giantButton'
                                                                iconStart={<span><AddShoppingCart style={{position: 'relative', zIndex: 1}}/></span>}
                                                                label='Tudo em Yamaha'
                                                                onClick={() => navigate('/produtos/Peças')}
                                                            />
                                                        </div>
                                                    </div>
                                                </SwiperSlide>
                                            }
                                        </>
                                    :
                                        <>
                                            {configData.defaultStore === 'Vigorito' &&
                                                <SwiperSlide>
                                                    <div className='defaultBannerBG' style={{ backgroundImage: `url(${isMobile ? contentData.bannerSpecialMobile : contentData.bannerSpecial})`, backgroundColor: 'var(--mainColor)' }}>
                                                        <div className='rowToColumn' style={{columnGap: '20px', rowGap: '10px'}}>
                                                            <img style={{maxHeight: !isMobile ? '380px' : '320px'}} src={isMobile ? contentData.imgSepcialMobile : contentData.imgSepcial} alt={`${isMobile ? contentData.imgSepcialMobile : contentData.imgSepcial} logo`} loading='lazy' />
                                                            <div className='column center' style={{textAlign: 'center', gap: '10px'}}>
                                                                {!isMobile &&
                                                                    <img className='BannerLogo' src={contentData.mainLogo} alt={`${configData.defaultStore} logo`} loading='lazy'/> 
                                                                }
                                                                <div className='column center' style={{textAlign: 'center', paddingInline: '10px'}}>
                                                                    <h2 style={{margin: '0', fontWeight: 'bold', fontSize: isMobile ? '16px' : '21px'}}> Segurança | Garantia</h2>
                                                                    {/* <span style={{margin: '0', color: 'var(--grayedText)'}}>*na grande SP</span> */}
                                                                    {/* <h2 style={{margin: '0', fontWeight: 'bold', fontSize: isMobile ? '16px' : '21px'}}>Entrega em 24h úteis* | Segurança | Garantia</h2> */}
                                                                </div>
                                                                <Button
                                                                    className='giantButton'
                                                                    iconStart={<span><AddCar style={{color: 'var(--giantButtonGradientContent)', position: 'relative', zIndex: 1}}/></span>}
                                                                    label={!selectedVersion ? 'Selecionar veículo' : 'Peças compatíveis'}
                                                                    onClick={openVehicleSelect}
                                                                />
                                                            </div>
                                                        </div>
                                                        {/* {!selectedVersion &&
                                                            <div className='startHereContainer'>
                                                                <div className='startHere' onClick={openVehicleSelect}>
                                                                    <KeyboardDoubleArrowUp style={{color: 'var(s--secondColor)'}}/>
                                                                    <span>Comece aqui</span>
                                                                </div>
                                                            </div>
                                                        } */}
                                                    </div>
                                                </SwiperSlide>
                                            }

                                            {/* {configData.defaultStore === 'Discautol' &&
                                                <SwiperSlide>
                                                    <div className='defaultBannerBG' style={{backgroundImage: `url(${contentData.bannerSpecial})`}}>
        
                                                        <div className='column center' style={{justifyContent: 'center', alignItems: 'center', gap: '20px', textAlign: 'center', paddingInline: '20px'}}>
                                                            <img className='BannerLogoHuge' src={contentData.imgSepcial} alt={`${configData.defaultStore} logo`} loading='lazy'/> 
                                                            <span>Promoção válida até 22/03/2025.</span>
                                                        </div>
                                                    </div>
                                                </SwiperSlide>
                                            } */}

                                            {configData.defaultStore === 'Carlider' &&
                                                <>
                                                    <SwiperSlide>
                                                        <div className='defaultBannerBG' style={{ backgroundImage: `url(${contentData.banner01})`, backgroundColor: 'var(--mainColor)' }}>
                                                            <div className='rowToColumn' style={{columnGap: '20px', rowGap: '10px'}}>
                                                                <h2 style={{margin: '0', marginInline: isMobile ? '20px' : '0', maxWidth: '450px', fontSize: isMobile ? '20px' : '24px', textAlign: isMobile ? 'center' : 'left'}}>Encontre aqui peças <span style={{fontWeight: 'bold'}}>novas e genuínas</span> para o seu carro com a empresa que você já confia!</h2>
                                                                <img style={{maxHeight: !isMobile ? '300px' : '210px'}} src={isMobile ? contentData.imgSepcialMobile : contentData.imgSepcial} alt={`${isMobile ? contentData.imgSepcialMobile : contentData.imgSepcial} logo`} loading='lazy' />
                                                                <div className='column center' style={{textAlign: 'center', gap: '10px'}}>
                                                                    {/* {!isMobile &&
                                                                        <img className='BannerLogo' src={contentData.bannerLogoWhite} alt={`${configData.defaultStore} logo`} loading='lazy'/> 
                                                                    } */}
                                                                    <div className='titleContainer' style={{flexDirection: 'column'}}>
                                                                        <h1><mark>1.</mark> Selecione seu veículo</h1>
                                                                        <h1><mark>2.</mark> Encontre a peça desejada</h1>
                                                                        <h1><mark>3.</mark> Compre e receba</h1>
                                                                    </div>
                                                                    <Button
                                                                        className='giantButton'
                                                                        iconStart={<span><AddCar style={{color: 'var(--giantButtonGradientContent)', position: 'relative', zIndex: 1}}/></span>}
                                                                        label={!selectedVersion ? 'Selecionar veículo' : 'Peças compatíveis'}
                                                                        onClick={openVehicleSelect}
                                                                    />
                                                                </div>
                                                            </div>
                                                            {/* {!selectedVersion &&
                                                                <div className='startHereContainer'>
                                                                    <div className='startHere' onClick={openVehicleSelect}>
                                                                        <KeyboardDoubleArrowUp style={{color: 'var(--secondColor)'}}/>
                                                                        <span>Comece aqui</span>
                                                                    </div>
                                                                </div>
                                                            } */}
                                                        </div>
                                                    </SwiperSlide>

                                                    <SwiperSlide>
                                                        <div className='defaultBannerBG' style={{ backgroundImage: `url(${contentData.banner02})`, backgroundColor: 'var(--mainColor)' }}>
                                                            <h2 style={{margin: '0', marginInline: '20px', fontSize: isMobile ? '18px' : '24px', textAlign: isMobile ? 'center' : 'left'}}>Veja como <span style={{fontWeight: 'bold'}}>é fácil comprar</span> as peças compatíveis que você precisa:</h2>
                                                            <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', flexWrap: 'wrap', gap: '16px'}}>
                                                                <img style={{maxHeight: isMobile ? '150px' : '240px'}} src={contentData.step1img} alt={`${configData.defaultStore} passo 1`} loading='lazy'/>
                                                                <img style={{maxHeight: isMobile ? '150px' : '240px'}} src={contentData.step2img} alt={`${configData.defaultStore} passo 2`} loading='lazy'/>
                                                                <img style={{maxHeight: isMobile ? '150px' : '240px'}} src={contentData.step3img} alt={`${configData.defaultStore} passo 3`} loading='lazy'/>
                                                            </div>
                                                            <Button
                                                                className='giantButton'
                                                                iconStart={<span><AddShoppingCart style={{color: 'var(--giantButtonGradientContent)', position: 'relative', zIndex: 1}}/></span>}
                                                                label='Comprar agora'
                                                                onClick={openVehicleSelect}
                                                            />
                                                        </div>
                                                    </SwiperSlide>

                                                    <SwiperSlide>
                                                        <div className='defaultBannerBG' style={{ backgroundImage: `url(${contentData.banner03})`, backgroundColor: 'var(--mainColor)', backgroundPosition: !isMobile ? 'center' : 'left'}}>
                                                            <div className='rowToColumn' style={{columnGap: '20px', rowGap: '10px'}}>
                                                                <div className='row' style={{width: !isMobile ? '35vw' : '100vw'}}>
                                                                    <img style={{maxHeight: isMobile ? '220px' : '360px'}} src={contentData.imgSpecial2} alt={`${configData.defaultStore} logo`} loading='lazy'/>
                                                                </div>
                                                                <div className='column' style={{width: !isMobile ? '45vw' : '90vw',color: 'var(--mainColor) !important', gap: '10px', alignItems: 'start', marginInline: isMobile ? '20px' : '0'}}>
                                                                    <h2 style={{margin: '0', fontSize: isMobile ? '20px' : '24px', textAlign: 'left'}}>Compre peças com <span style={{fontWeight: 'bold'}}>facilidade e tranquilidade</span>!</h2>
                                                                    <span style={{textAlign: 'left', fontSize: isMobile ? '14px' : '18px'}}>
                                                                        Pagamento seguro via <span style={{fontWeight: 'bold'}}>PIX</span> ou em até <span style={{fontWeight: 'bold'}}>{configData.maxParcels}x</span> no cartão de crédito.<br/>Selecione o modelo do seu carro, a peça desejada e receba na sua casa.
                                                                    </span>
                                                                    <div className='row center' style={{gap: '10px'}}>
                                                                        <Button
                                                                            className='buttonColorSecond smallButton'
                                                                            label='Criar conta'
                                                                            onClick={() => navigate('/minha-conta')}
                                                                        />
                                                                        <Button
                                                                            className='buttonColorMain smallButton'
                                                                            label='Ver peças'
                                                                            onClick={openVehicleSelect}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </SwiperSlide>
                                                </>
                                            }

                                            {/* {configData.defaultStore === 'Provence' &&
                                                <SwiperSlide>
                                                    <div className='defaultBannerBG' style={{backgroundImage: `url(${isMobile ? contentData.bannerFreeShippingMobile : contentData.bannerFreeShippingDesk})`, backgroundColor: 'var(--mainColor)'}}>
                                                        <div className='column center' style={{gap: '20px', height: '100%', alignItems: 'center', justifyContent: 'end', marginBottom: '60px'}}>
                                                            <Button
                                                                className='buttonColorThird giantButton'
                                                                iconStart={<span><AddShoppingCart style={{color: 'var(--giantButtonGradientContent)', position: 'relative', zIndex: 1}}/></span>}
                                                                label='Ver peças'
                                                                onClick={openVehicleSelect}
                                                            />
                                                        </div>
                                                    </div>
                                                </SwiperSlide>
                                            } */}


    
                                            {configData.defaultStore !== 'Carlider' &&
                                                <SwiperSlide>
                                                    <div className='defaultBannerBG' style={{backgroundImage: `url(${contentData.banner01})`, backgroundColor: 'var(--mainColor)'}}>
                                                        <div className='rowToColumn center' style={{gap: '20px'}}>
                                                            <div className='column center'>
                                                                <img className={configData.defaultStore === 'Barigui' ? 'BannerLogoMedium' : 'BannerLogoLarge'} src={contentData.bannerImg01} alt={`${configData.defaultStore} logo`} loading='lazy'/>
                                                            </div>
                                                            <div className='column center' style={{gap: '10px'}}>
                                                                {configData.defaultStore === 'Barigui' && isMobile
                                                                ?
                                                                    <></>
                                                                :
                                                                    <h2 className='bannerHighlightText' dangerouslySetInnerHTML={{ __html: contentData.bannerHighlight }} />
                                                                }
        
                                                                {/* {!selectedVersion &&
                                                                    <div className='titleContainer not500' style={{flexDirection: 'column'}}>
                                                                        <h1><mark>1.</mark> Selecione seu veículo</h1>
                                                                        <h1><mark>2.</mark> Encontre a peça desejada</h1>
                                                                        <h1><mark>3.</mark> Compre e receba</h1>
                                                                    </div>
                                                                } */}
        
                                                                {!selectedVersion &&
                                                                    <div className='only500'>
                                                                        <h1>Selecione seu veículo:</h1>
                                                                    </div>
                                                                }
                                                                
                                                                {/* {selectedVersion &&
                                                                    <h1>Veículo selecionado:</h1>
                                                                } */}
                                                                
                                                                {/* {!selectedVersion &&
                                                                    <div className='startHereContainer'>
                                                                        <div className='startHere' onClick={openVehicleSelect}>
                                                                            <KeyboardDoubleArrowUp style={{color: 'var(--secondColor)'}}/>
                                                                            <span>Comece aqui</span>
                                                                        </div>
                                                                    </div>
                                                                } */}
                                                                
                                                                {!selectedVersion
                                                                    ?
                                                                        <div className='column center' style={{gap: '10px'}}>
                                                                            <div className='bannerRowBrands'>
                                                                                {configData.brands.map((item) => {
                                                                                    const brandName = item.charAt(0).toUpperCase() + item.slice(1);
                                                                                    const imageSrc = BrandsList[brandName];
                                                                                    return imageSrc ? (
                                                                                    <div
                                                                                        className='headerFilterOption'
                                                                                        key={item}
                                                                                        onClick={() => vehicleSelectWithBrand(item)}
                                                                                    >
                                                                                        <img className='headerFilterBrandLogo' src={imageSrc} alt={item} />
                                                                                    </div>
                                                                                    ) : (
                                                                                    <div className='headerFilterOption' style={{ color: 'white' }} key={item}>
                                                                                        {item}
                                                                                    </div>
                                                                                    );
                                                                                })}
                                                                            </div>
                                                                        </div>
                                                                    :
                                                                        <div className='column center' style={{gap: '10px'}}>
                                                                            <div className='row selectedVehicleHomeBanner' onClick={openVehicleSelectOnly}>
                                                                                <img className='catVehicleImg' src={modelSeriesImg(modelSeries)}/>
                                                                                <span style={{alignItems: 'center', whiteSpace: 'wrap'}} >{selectedModel} {selectedYear} {selectedVersion}</span>
                                                                                <a style={{whiteSpace: 'nowrap'}}><Edit style={{fontSize: '16px', marginLeft: '6px'}}/> alterar</a>
                                                                            </div>
                                                                            <Button
                                                                                className='giantButton'
                                                                                iconStart={<span><AddShoppingCart style={{color: 'var(--giantButtonGradientContent)', position: 'relative', zIndex: 1}}/></span>}
                                                                                label='Peças compatíveis'
                                                                                onClick={openVehicleSelect}
                                                                            />
                                                                        </div>
                                                                }
        
                                                            </div>
        
                                                        </div>
        
                                                    </div>
                                                </SwiperSlide>
                                            }

                                            {configData.defaultStore === 'Barigui' &&
                                                <>
                                                    <SwiperSlide>
                                                        <div className='defaultBannerBG' style={{backgroundImage: `url(${contentData.banner04})`}}>
                                                            <div className='rowToColumn1280 center' style={{height: '100%', alignItems: 'center', justifyContent: 'center', marginBottom: '60px'}}>
                                                                <div className='column center' style={{gap: '10px', width: '100%'}}>
                                                                    <img src={isMinDesktop ? contentData.bannerImgKits_desk : contentData.bannerImgKits_mobile} className='bannerImgHalf' style={{width: isMinDesktop ? '420px' : '280px'}} alt='kits de revisão e manutenção automotiva'/>
                                                                    <div className='row center' style={{position: 'absolute', top: isMinDesktop ? '330px' : '200px', gap: '10px'}}>
                                                                        <span className='smallButton discountHighlight' style={{height: '28px'}}>63% off</span>
                                                                        <span className='smallButton discountHighlight' style={{height: '28px'}}>57% off</span>
                                                                        <span className='smallButton discountHighlight' style={{height: '28px'}}>42% off</span>
                                                                    </div>
                                                                </div>
                                                                <div className='column center' style={{gap: '10px', width: '100%'}}>
                                                                    <h2 className='bannerHighlightTextLarge' style={{color: 'var(--mainColor)'}}>Kits de Revisão e Manutenção com os <mark>Melhores Preços!</mark></h2>
                                                                    {!selectedVersion
                                                                    ?
                                                                        <h2 className='bannerHighlightText' style={{color: 'var(--mainColor)'}}>Selecione seu veículo e confira os kits compatíveis de troca de óleo, correias, velas e mais.</h2>
                                                                    :
                                                                        <>
                                                                            <h2 className='bannerHighlightText' style={{color: 'var(--mainColor)'}}>Confira os kits compatíveis com:</h2>
                                                                            <div className='row selectedVehicleHomeBanner' onClick={openVehicleSelectOnly}>
                                                                                <img className='catVehicleImg' src={modelSeriesImg(modelSeries)}/>
                                                                                <span style={{alignItems: 'center', whiteSpace: 'wrap'}} >{selectedModel} {selectedYear} {selectedVersion}</span>
                                                                                <a style={{whiteSpace: 'nowrap'}}><Edit style={{fontSize: '16px', marginLeft: '6px'}}/> alterar</a>
                                                                            </div>
                                                                        </>
                                                                    }
                                                                    <Button
                                                                        className='buttonColorThird giantButtonMain'
                                                                        iconStart={<span><AddShoppingCart style={{color: 'var(--mainContent)', position: 'relative', zIndex: 1}}/></span>}
                                                                        label='Ver Kits Compatíveis'
                                                                        onClick={() => navigate('/busca/kit')}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </SwiperSlide>

                                                    <SwiperSlide>
                                                        <div className='defaultBannerBG' style={{backgroundImage: `url(${contentData.bannerStudio})`}}>
                                                            <div className='rowToColumn1280 center' style={{height: '100%', alignItems: 'center', justifyContent: 'center', marginBottom: '60px'}}>
                                                                <img src={contentData.acessImg} className='bannerImgHalf' alt='Acessórios Automotivos'/>
                                                                <div className='column center' style={{gap: '10px', width: '100%'}}>
                                                                    <h2 className='bannerHighlightTextLarge' style={{color: 'var(--mainColor)'}}>Acessórios Originais para dirigir com a <mark>Melhor Experiência</mark></h2>
                                                                    <div className='column center' style={{maxWidth: '440px', marginInline: '10px', gap: '10px', borderRadius: '6px', backgroundColor: 'white', padding: '10px'}}>
                                                                        <div className='row center'>
                                                                            <img src={acessIcon} alt='Icone Categoria Acessórios' style={{width: '64px', height: '64px', objectFit: 'contain'}}/>
                                                                            <h2 className='bannerHighlightText' style={{color: 'var(--mainColor)', textAlign: 'start', margin: '0'}}>Acesse para comprar <mark>acessórios compatíveis</mark>:</h2>
                                                                        </div>
                                                                        <Button
                                                                            className='buttonColorThird smallButton'
                                                                            iconStart={<span><AddShoppingCart style={{color: 'var(--thirdContent)', position: 'relative', zIndex: 1}}/></span>}
                                                                            label='Comprar agora'
                                                                            onClick={() => navigate('/produtos/Acessórios')}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </SwiperSlide>

                                                    {/* <SwiperSlide>
                                                        <div className='defaultBannerBG' style={{backgroundImage: `url(${isMinDesktop ? contentData.bannerBydDesk : contentData.bannerBydMobile})`, backgroundColor: 'var(--mainColor)'}}>
                                                            <div className='rowToColumn1280 center' style={{height: '100%', alignItems: 'center', justifyContent: 'center', marginBottom: '60px'}}>
                                                                <div className='column center' style={{gap: '10px', width: '100%', height: '50%'}}></div>
                                                                <div className='column center' style={{gap: '10px', width: '100%'}}>
                                                                    <img src={BrandsListPng['Byd']} style={{width: '180px'}}/>
                                                                    <h2 className='bannerHighlightTextLarge' style={{color: 'var(--mainColor)'}}>Peças originais <mark>BYD</mark> com os melhores preços!</h2>
                                                                    <div className='row center' style={{gap: '10px', maxWidth: '320px', flexWrap: 'wrap'}}>
                                                                        <span className='smallButton discountHighlight' style={{height: '28px'}}>68% off</span>
                                                                        <span className='smallButton discountHighlight' style={{height: '28px'}}>48% off</span>
                                                                        <span className='smallButton discountHighlight' style={{height: '28px'}}>40% off</span>
                                                                        <span className='smallButton discountHighlight' style={{height: '28px'}}>35% off</span>
                                                                        <span className='smallButton discountHighlight' style={{height: '28px'}}>27% off</span>
                                                                    </div>
                                                                    {selectedBrand === 'byd'
                                                                        ?
                                                                            <Button
                                                                                className='buttonColorThird giantButton'
                                                                                iconStart={<span><AddShoppingCart style={{color: 'var(--giantButtonGradientContent)', position: 'relative', zIndex: 1}}/></span>}
                                                                                label='Ver peças BYD'
                                                                                onClick={openVehicleSelect}
                                                                            />
                                                                        :
                                                                            <Button
                                                                                className='buttonColorThird giantButton'
                                                                                iconStart={<span><AddShoppingCart style={{color: 'var(--giantButtonGradientContent)', position: 'relative', zIndex: 1}}/></span>}
                                                                                label='Selecione seu BYD'
                                                                                onClick={() => vehicleSelectWithBrand('byd')}
                                                                            />
                                                                    }
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </SwiperSlide> */}

                                                    {/* <SwiperSlide>
                                                        <div className='defaultBannerBG' style={{backgroundImage: `url(${isMinDesktop ? contentData.bannerFordDesk : contentData.bannerFordMobile})`, backgroundColor: 'var(--mainColor)'}}>
                                                            <div className='column center' style={{gap: '10px', width: '100%'}}>
                                                                <img src={BrandsListPng['Ford']} style={{width: '180px'}}/>
                                                                <h2 className='bannerHighlightTextLarge'>Peças <mark>FORD</mark> com garantia e qualidade de fábrica!</h2>
                                                                <div className='row center' style={{gap: '10px', maxWidth: '320px', flexWrap: 'wrap'}}>
                                                                    <span className='smallButton discountHighlight' style={{height: '28px'}}>98% off</span>
                                                                    <span className='smallButton discountHighlight' style={{height: '28px'}}>95% off</span>
                                                                    <span className='smallButton discountHighlight' style={{height: '28px'}}>90% off</span>
                                                                </div>
                                                                {selectedBrand === 'ford'
                                                                    ?
                                                                        <Button
                                                                            className='buttonColorThird giantButton'
                                                                            iconStart={<span><AddShoppingCart style={{color: 'var(--giantButtonGradientContent)', position: 'relative', zIndex: 1}}/></span>}
                                                                            label='Ver peças FORD'
                                                                            onClick={openVehicleSelect}
                                                                        />
                                                                    :
                                                                        <Button
                                                                            className='buttonColorThird giantButton'
                                                                            iconStart={<span><AddShoppingCart style={{color: 'var(--giantButtonGradientContent)', position: 'relative', zIndex: 1}}/></span>}
                                                                            label='Selecione seu FORD'
                                                                            onClick={() => vehicleSelectWithBrand('ford')}
                                                                        />
                                                                }
                                                            </div>
                                                        </div>
                                                    </SwiperSlide> */}

                                                   <SwiperSlide>
                                                        <div className='defaultBannerBG' style={{backgroundImage: `url(${isMinDesktop ? contentData.bannerVwDesk : contentData.bannerVwMobile})`, backgroundColor: 'var(--mainColor)'}}>
                                                            <div className='column center' style={{gap: '10px', width: '100%'}}>
                                                                <img src={BrandsListPng['Volkswagen']} style={{width: '140px'}}/>
                                                                <h2 className='bannerHighlightTextLarge'>Peças genuínas <mark>VOLKSWAGEN</mark> direto das concessionárias Barigui Volkswagen!</h2>
                                                                <div className='row center' style={{gap: '10px', maxWidth: '320px', flexWrap: 'wrap'}}>
                                                                    <span className='smallButton discountHighlight' style={{height: '28px'}}>80% off</span>
                                                                    <span className='smallButton discountHighlight' style={{height: '28px'}}>78% off</span>
                                                                    <span className='smallButton discountHighlight' style={{height: '28px'}}>76% off</span>
                                                                </div>
                                                                {selectedBrand === 'volkswagen'
                                                                    ?
                                                                        <Button
                                                                            className='buttonColorThird giantButton'
                                                                            iconStart={<span><AddShoppingCart style={{color: 'var(--giantButtonGradientContent)', position: 'relative', zIndex: 1}}/></span>}
                                                                            label='Ver peças VOLKSWAGEN'
                                                                            onClick={openVehicleSelect}
                                                                        />
                                                                    :
                                                                        <Button
                                                                            className='buttonColorThird giantButton'
                                                                            iconStart={<span><AddShoppingCart style={{color: 'var(--giantButtonGradientContent)', position: 'relative', zIndex: 1}}/></span>}
                                                                            label='Selecione seu VOLKSWAGEN'
                                                                            onClick={() => vehicleSelectWithBrand('volkswagen')}
                                                                        />
                                                                }
                                                            </div>
                                                        </div>
                                                    </SwiperSlide>

                                                    <SwiperSlide>
                                                        <div className='defaultBannerBG' style={{backgroundImage: `url(${isMinDesktop ? contentData.bannerRenaultDesk : contentData.bannerRenaultMobile})`, backgroundColor: 'var(--mainColor)'}}>
                                                            <div className='column center' style={{gap: '10px', width: '100%'}}>
                                                                <img src={BrandsListPng['Renault']} style={{width: '150px'}}/>
                                                                <h2 className='bannerHighlightTextLarge'>Peças <mark>RENAULT</mark> com garantia e qualidade de fábrica!</h2>
                                                                <div className='row center' style={{gap: '10px', maxWidth: '320px', flexWrap: 'wrap'}}>
                                                                    <span className='smallButton discountHighlight' style={{height: '28px'}}>86% off</span>
                                                                    <span className='smallButton discountHighlight' style={{height: '28px'}}>72% off</span>
                                                                    <span className='smallButton discountHighlight' style={{height: '28px'}}>62% off</span>
                                                                </div>
                                                                {selectedBrand === 'renault'
                                                                    ?
                                                                        <Button
                                                                            className='buttonColorThird giantButton'
                                                                            iconStart={<span><AddShoppingCart style={{color: 'var(--giantButtonGradientContent)', position: 'relative', zIndex: 1}}/></span>}
                                                                            label='Ver peças RENAULT'
                                                                            onClick={openVehicleSelect}
                                                                        />
                                                                    :
                                                                        <Button
                                                                            className='buttonColorThird giantButton'
                                                                            iconStart={<span><AddShoppingCart style={{color: 'var(--giantButtonGradientContent)', position: 'relative', zIndex: 1}}/></span>}
                                                                            label='Selecione seu RENAULT'
                                                                            onClick={() => vehicleSelectWithBrand('renault')}
                                                                        />
                                                                }
                                                            </div>
                                                        </div>
                                                    </SwiperSlide>

                                                    <SwiperSlide>
                                                        <div className='defaultBannerBG' style={{backgroundImage: `url(${isMinDesktop ? contentData.bannerFiatDesk : contentData.bannerFiatMobile})`, backgroundColor: 'var(--mainColor)'}}>
                                                            <div className='rowToColumn1280 center' style={{height: '100%', alignItems: 'center', justifyContent: 'center', marginBottom: '60px'}}>
                                                                <div className='column center' style={{gap: '10px', width: '100%', height: '50%'}}></div>
                                                                <div className='column center' style={{gap: '10px', width: '100%', minWidth: '360px', maxWidth: '480px'}}>
                                                                    <img src={BrandsListPng['Fiat']} style={{width: '140px'}}/>
                                                                    <h2 className='bannerHighlightTextLarge'>Escolha o melhor para o seu <mark>FIAT</mark>!</h2>
                                                                    <div className='row center' style={{gap: '10px', maxWidth: '320px', flexWrap: 'wrap'}}>
                                                                        <span className='smallButton discountHighlight' style={{height: '28px'}}>99% off</span>
                                                                        <span className='smallButton discountHighlight' style={{height: '28px'}}>94% off</span>
                                                                        <span className='smallButton discountHighlight' style={{height: '28px'}}>86% off</span>
                                                                    </div>
                                                                    {selectedBrand === 'fiat'
                                                                        ?
                                                                            <Button
                                                                                className='buttonColorThird giantButton'
                                                                                iconStart={<span><AddShoppingCart style={{color: 'var(--giantButtonGradientContent)', position: 'relative', zIndex: 1}}/></span>}
                                                                                label='Ver peças FIAT'
                                                                                onClick={openVehicleSelect}
                                                                            />
                                                                        :
                                                                            <Button
                                                                                className='buttonColorThird giantButton'
                                                                                iconStart={<span><AddShoppingCart style={{color: 'var(--giantButtonGradientContent)', position: 'relative', zIndex: 1}}/></span>}
                                                                                label='Selecione seu FIAT'
                                                                                onClick={() => vehicleSelectWithBrand('fiat')}
                                                                            />
                                                                    }
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </SwiperSlide>

                                                    <SwiperSlide>
                                                        <div className='defaultBannerBG' style={{backgroundImage: `url(${isMinDesktop ? contentData.bannerNissanDesk : contentData.bannerNissanMobile})`, backgroundColor: 'var(--mainColor)'}}>
                                                            <div className='column center' style={{gap: '10px', width: '100%'}}>
                                                                <img src={BrandsListPng['Nissan']} style={{width: '180px'}}/>
                                                                <h2 className='bannerHighlightTextLarge'>Cuide bem do seu <mark>NISSAN</mark> com peças novas e originais!</h2>
                                                                <div className='row center' style={{gap: '10px', maxWidth: '320px', flexWrap: 'wrap'}}>
                                                                    <span className='smallButton discountHighlight' style={{height: '28px'}}>88% off</span>
                                                                    <span className='smallButton discountHighlight' style={{height: '28px'}}>78% off</span>
                                                                    <span className='smallButton discountHighlight' style={{height: '28px'}}>68% off</span>
                                                                </div>
                                                                {selectedBrand === 'nissan'
                                                                    ?
                                                                        <Button
                                                                            className='buttonColorThird giantButton'
                                                                            iconStart={<span><AddShoppingCart style={{color: 'var(--giantButtonGradientContent)', position: 'relative', zIndex: 1}}/></span>}
                                                                            label='Ver peças NISSAN'
                                                                            onClick={openVehicleSelect}
                                                                        />
                                                                    :
                                                                        <Button
                                                                            className='buttonColorThird giantButton'
                                                                            iconStart={<span><AddShoppingCart style={{color: 'var(--giantButtonGradientContent)', position: 'relative', zIndex: 1}}/></span>}
                                                                            label='Selecione seu NISSAN'
                                                                            onClick={() => vehicleSelectWithBrand('nissan')}
                                                                        />
                                                                }
                                                            </div>
                                                        </div>
                                                    </SwiperSlide>

                                                    <SwiperSlide>
                                                        <div className='defaultBannerBG' style={{backgroundImage: `url(${isMinDesktop ? contentData.bannerCheryDesk : contentData.bannerCheryMobile})`, backgroundColor: 'var(--mainColor)'}}>
                                                            <div className='rowToColumn1280 center' style={{height: '100%', alignItems: 'center', justifyContent: 'center', marginBottom: '60px'}}>
                                                                <div className='column center' style={{gap: '10px', width: '100%', height: '50%'}}></div>
                                                                <div className='column center' style={{gap: '10px', width: '100%', minWidth: '360px', maxWidth: '480px'}}>
                                                                    <img src={BrandsListPng['Chery']} style={{width: '200px'}}/>
                                                                    <h2 className='bannerHighlightTextLarge'>Peças novas e originais direto da <mark>CAOA Chery Barigüi</mark></h2>
                                                                    <div className='row center' style={{gap: '10px', maxWidth: '320px', flexWrap: 'wrap'}}>
                                                                        <span className='smallButton discountHighlight' style={{height: '28px'}}>57% off</span>
                                                                        <span className='smallButton discountHighlight' style={{height: '28px'}}>48% off</span>
                                                                        <span className='smallButton discountHighlight' style={{height: '28px'}}>42% off</span>
                                                                    </div>
                                                                    {selectedBrand === 'chery'
                                                                        ?
                                                                            <Button
                                                                                className='buttonColorThird giantButton'
                                                                                iconStart={<span><AddShoppingCart style={{color: 'var(--giantButtonGradientContent)', position: 'relative', zIndex: 1}}/></span>}
                                                                                label='Ver peças CHERY'
                                                                                onClick={openVehicleSelect}
                                                                            />
                                                                        :
                                                                            <Button
                                                                                className='buttonColorThird giantButton'
                                                                                iconStart={<span><AddShoppingCart style={{color: 'var(--giantButtonGradientContent)', position: 'relative', zIndex: 1}}/></span>}
                                                                                label='Selecione seu CHERY'
                                                                                onClick={() => vehicleSelectWithBrand('chery')}
                                                                            />
                                                                    }
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </SwiperSlide>

                                                    {/* <SwiperSlide>
                                                        <div className='defaultBannerBG' style={{backgroundImage: `url(${isMinDesktop ? contentData.bannerBmwDesk : contentData.bannerBmwMobile})`, backgroundColor: 'var(--mainColor)'}}>
                                                            <div className='rowToColumn1280 center' style={{height: '100%', alignItems: 'center', justifyContent: 'center', marginBottom: '60px'}}>
                                                                <div className='column center' style={{gap: '10px', width: '100%', height: '50%'}}></div>
                                                                <div className='column center' style={{gap: '10px', width: '100%'}}>
                                                                    <img src={BrandsListPng['Bmw']} style={{width: '140px'}}/>
                                                                    <h2 className='bannerHighlightTextLarge'>Para quem exige o melhor, utilize peças genuínas <mark>BMW</mark>.</h2>
                                                                    <div className='row center' style={{gap: '10px', maxWidth: '320px', flexWrap: 'wrap'}}>
                                                                        <span className='smallButton discountHighlight' style={{height: '28px'}}>17% off</span>
                                                                    </div>
                                                                    {selectedBrand === 'bmw'
                                                                        ?
                                                                            <Button
                                                                                className='buttonColorThird giantButton'
                                                                                iconStart={<span><AddShoppingCart style={{color: 'var(--giantButtonGradientContent)', position: 'relative', zIndex: 1}}/></span>}
                                                                                label='Ver peças BMW'
                                                                                onClick={openVehicleSelect}
                                                                            />
                                                                        :
                                                                            <Button
                                                                                className='buttonColorThird giantButton'
                                                                                iconStart={<span><AddShoppingCart style={{color: 'var(--giantButtonGradientContent)', position: 'relative', zIndex: 1}}/></span>}
                                                                                label='Selecione seu BMW'
                                                                                onClick={() => vehicleSelectWithBrand('bmw')}
                                                                            />
                                                                    }
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </SwiperSlide> */}
                                                </>
                                            }
    
                                            {configData.defaultStore === 'Vigorito' &&
                                                <SwiperSlide>
                                                    <div className='defaultBannerBG' style={{backgroundImage: `url(${contentData.banner05})`}}>
                                                        <div className='rowToColumn center' style={{gap: '20px'}}>
                                                            <div className='column center' style={{gap: '10px', paddingInline: '10px'}}>
                                                                <h2 className= 'bannerHighlightTextLarge'><span style={{color: 'white', fontWeight: 'bold'}}>Kits</span> de <span style={{color: 'yellow', fontWeight: 'bold'}}>Revisão e Manutenção</span></h2>
                                                                <span style={{paddingInline: '10px'}}>Kits completos com itens de fábrca para troca de óleo, revisão, correias e outros.</span>
                                                                <Button
                                                                    className='giantButton'
                                                                    iconStart={<span><KeyboardArrowDown style={{color: 'var(--giantButtonGradientContent)', position: 'relative', zIndex: 1}}/></span>}
                                                                    label='Confira!'
                                                                />
                                                            </div>
                                                            <img className='BannerLogoLarge' src={contentData.bannerImg05} alt={`${configData.defaultStore} logo`} loading='lazy'/>
                                                        </div>
                                                    </div>
                                                </SwiperSlide>
                                            }
    
                                            {configData.defaultStore !== 'Carlider' &&
                                                <SwiperSlide>
                                                    {/* <div className='defaultBannerBG' style={{backgroundColor: 'var(--secondColor)'}}> */}
                                                    <div className='defaultBannerBG' style={{backgroundImage: `url(${contentData.banner02})`, backgroundColor: 'var(--mainColor)'}}>
        
                                                        {/* <img src={Logo} className='BannerLogo'/> */}
        
                                                        <h2 className='bannerHighlightText' dangerouslySetInnerHTML={{ __html: contentData.bannerHighlight }} />
        
                                                        <div className='stepsBannerRow'>
                                                            <img src={contentData.car123 === '' ? carBanner : contentData.car123} className='bannerStepsImg'/>
                                                            <ChevronRight/>
                                                            <img src={partsBanner} className='bannerStepsImg'/>
                                                            <ChevronRight/>
                                                            <img src={contentData.box123 === '' ? boxGpBanner : contentData.box123} className='bannerStepsImg'/>
                                                        </div>
        
                                                        <div className='titleContainer'>
                                                            <h1><mark>1.</mark> Selecione seu veículo</h1>
                                                            <h1><mark>2.</mark> Encontre a peça desejada</h1>
                                                            <h1><mark>3.</mark> Compre e receba</h1>
                                                        </div>
        
                                                        {/* <h1>Autopeças <mark>novas e origniais</mark> compatíveis com <mark>seu veículo</mark> e enviadas diretamente pelas <mark>concessionárias</mark>.</h1> */}
                                                        
                                                        {/* {!selectedVersion &&
                                                            <div className='startHereContainer'>
                                                                <div className='startHere' onClick={openVehicleSelect}>
                                                                    <KeyboardDoubleArrowUp style={{color: 'var(--secondColor)'}}/>
                                                                    <span>Comece aqui</span>
                                                                </div>
                                                            </div>
                                                        } */}
                                                        <div className='row center'style={{gap: '10px'}}>
                                                            <Button
                                                                className='giantButton'
                                                                iconStart={<span><AddCar style={{color: 'var(--giantButtonGradientContent)', position: 'relative', zIndex: 1}}/></span>}
                                                                label={!selectedVersion ? 'Selecionar veículo' : 'Peças compatíveis'}
                                                                onClick={openVehicleSelect}
                                                            />
        
                                                            {/* <Button
                                                                className='buttonStyle colorButtonMain largeButton'
                                                                label='Encontrar peças'
                                                            /> */}
                                                        </div>
        
        
                                                        {/* <div className='stepsBannerRow'>
                                                            <img src={carBanner} className='bannerStepsImg'/>
                                                            <ChevronRight/>
                                                            <img src={partsBanner} className='bannerStepsImg'/>
                                                            <ChevronRight/>
                                                            <img src={boxGpBanner} className='bannerStepsImg'/>
                                                        </div> */}
        
                                                    </div>
                                                </SwiperSlide>
                                            }
                                        </>
                                    }
            
                                </>
                            }
                        </>
                }
                
            </Swiper>
        </div>
    );
}

export default BannerSlider;